import { IImagePopulated } from "@/types/images.types";

const sizeMap: Record<Img["type"], number> = {
  mobile: 320,
  tablet: 640,
  desktop: 1280,
  large: 1920,
  original: 2560, // умовно
};

export const buildSrcSet = (images: IImagePopulated[]) =>
  images
    .filter((i) => i.type !== "original")
    .map((i) => `${i.url} ${sizeMap[i.type]}w`)
    .join(", ");

export const getFallbackSrc = (variants: IImagePopulated[]) =>
  variants.find((i) => i.type === "original")?.url ||
  variants.find((i) => i.type === "desktop")?.url ||
  variants.find((i) => i.type === "tablet")?.url ||
  variants.find((i) => i.type === "mobile")?.url ||
  "";
